import mitt from 'mitt';

const globalEvents = mitt();

window.events = globalEvents;
export default globalEvents;



// WEBPACK FOOTER //
// ./src/events.js